module.exports = __webpack_public_path__ + "img/source_main-con03.22ede994.png";